import axios from "axios";
import ipConfig from "./ipconfig";
import { applySign } from './sign';
// import { get } from "core-js/core/dict";
// const os = require('os')
// let localhost = ''
// try {
//   const network = os.networkInterfaces()
//   localhost = network[Object.keys(network)[0]][1].address
// } catch (e) {
//   localhost = 'localhost';
// }
const request = axios.create({
    // baseURL:'http://192.168.1.101:8084',
    // baseURL:'http://192.168.0.188:8100', 
    // baseURL:'localhost', 
    baseURL:ipConfig.baseUrl, 
    timeout:10000 ,
    headers:{'Content-Type':'application/x-www-form-urlencoded'},
    // headers: {'Content-Type': 'application/json;charset=utf-8'},
    // withCredentials: true
})

//请求拦截
request.interceptors.request.use(
    // config.headers['Access-Control-Allow-Credentials'] = true,
    config => {
    //这里根据项目的实际情况，可在请求时对自己的请求信息添加信息
    //比如在请求头中添加校验身份的token或uuid等内容
    //  config.headers['Authorization'] ="Bearer"+' '+sessionStorage.getItem('token')
    // config.headers['Access-Control-Allow-Credentials'] = true
        return applySign(config)
    },
    error => {
        return Promise.reject(error)
    }
)
//响应拦截
request.interceptors.response.use(
    response => {
    //这里可初步对响应体进行筛选
   //根据自己实际的后端项目返回内容的设计，比如在不同的状态下代表着不同的意思，可直接作出相应的事件
   //例如返回响应状态为200，这里可直接返回响应体中的data，不必返回全部的响应体
   //再或者状态位401，未登录，那就可以直接在这里写重定向到登录页面等等
        if(response.status === 200) {
            return response
        }else {
            console.log({
                message: response.statusText
            })
            return Promise.reject(new Error(response.statusText))
        }
    },
    error => {
        console.log({
            message: error.message
        })
        return Promise.reject(error)
    }
)



export default request 




// WEBPACK FOOTER //
// ./src/utils/request.js